import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const CompanySummaryPage = lazy(() => import('./CompanySummaryPage'));

const CompanySummaryConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.CompanySummary,
  routes: [
    {
      path: 'company-summary',
      element: <CompanySummaryPage />,
    },
  ],
};

export default CompanySummaryConfig;
